// import Grid from "@material-ui/core/Grid";
// import range from "lodash/range";
import React from "react";
// import RadioScale from "src/shared/components/RadioScale";
// import { TemplateType, TemplateTypeUtil } from "src/api/types";
// import { noneIdValue } from "../../TemplateEditorPage";
// import { useStyles } from "./styles";
import { ITemplateSettingsProps } from "./types";
import { Box } from "@material-ui/core";

export const TemplateSettings = ({
  SaveButtonWithProps,
  name,
  templates,
  // parentId,
  templateId,
  copyId,
  defaultPositiveText,
  defaultNegativeText,
  defaultReversed,
  defaultScale,
  enableParentQuestions,
  scalePreview,
  templateType,
  parentTemplate,
  // handleParentTemplateChange,
  handleTemplateTypeChange,
  handleCopyTemplateChange,
  handleEnableParentQuestions,
  handleReversedChange,
  handleScaleChange,
  loadCopyQuestions,
  handleNameChange,
  handleDefaultPositiveTextChange,
  handleDefaultNegativeTextChange,
  handleScalePreviewChange,
}: ITemplateSettingsProps) => {
  // const classes = useStyles();

  return (
    <Box>
      <SaveButtonWithProps />
      {/* <div className="name-copy-inner">
      <div className="name-inner-input">
      <label>
        Name:
        </label>
        <br/>
        <input
        className="template-int"
          placeholder="Template Name"
          value={name}
          onChange={handleNameChange}
        />
     
        <p>
          <input
            type="checkbox"
            checked={enableParentQuestions}
            onChange={handleEnableParentQuestions}
          />{" "}
          Enable parent evaluations on this template?
        </p>
        </div>
        </div>
      {parentTemplate && (
        <span className={classes.warning}>
          Template is a parent. If you want to make it inherit you must remove
          all children first.
        </span>
      )}
      {/* {(templates.length !== 0 || !parentTemplate) && ( */}
      
          {/* TODO: completely remove inherit feature (API logic included) :: Confirm first with Kevin before removing */}
          {/* Inherit:
          <select
            onChange={(e) => {
              console.log("this is running");
              handleParentTemplateChange(e);
            }}
            value={parentId === null ? noneIdValue : parentId}
          >
            <option key="none" value={noneIdValue} />
            {templates
              .filter(
                (template) =>
                  template.parentId === null && templateId !== template.id
              )
              .map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
          </select> */}
          {/* Copy:
          <select
            onChange={handleCopyTemplateChange}
            value={copyId === null ? noneIdValue : copyId}
          >
            <option key="none" value={noneIdValue} />
            {templates
              .filter(
                (template) =>
                  template.parentId === null && templateId !== template.id
              )
              .map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
          </select>
          <button onClick={loadCopyQuestions}>Copy</button> 
     
        
      
    
 
      <div className="grit-select-inner">
        <select onChange={handleTemplateTypeChange} value={templateType}>
          {[
            TemplateType.gritLeadership,
            TemplateType.noGridNoCoach,
            TemplateType.noGrid,
          ].map((s: TemplateType) => (
            <option key={s} value={s}>
              {TemplateTypeUtil.templateTypeToString(s)}
            </option>
          ))}
        </select>
      </div>
      <div style={{padding:"15px"}} className={classes.defaultScaleProperties}>
      <div className="scale-select">
      <label>
          Default Scale Properties: 
          </label><br />
          <label>
          Scale:</label>
          <br/>
          <select onChange={handleScaleChange} value={defaultScale.toString()}>
            {range(1, 11).map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </div>
        <div className="reverse">
        <label> Reversed:</label>
          <input
            checked={defaultReversed}
            onChange={handleReversedChange}
            type="checkbox"
          />
         </div>
        <div className="positive-negative">
        <div className="positive-inner">
        <label> Positive Text:</label><br/>
        <textarea
          rows={2}
          value={defaultPositiveText}
          onChange={handleDefaultPositiveTextChange}
        />
       </div>
        <div className="negative-inner">
        <label>
        Negative Text:</label><br/>
        <textarea
          rows={2}
          value={defaultNegativeText}
          onChange={handleDefaultNegativeTextChange}
        /></div>  </div>
        <br />
        <Grid container={true} direction="row" alignItems="center">
          <span>Preview: </span>
          <Box className={classes.radioPreview}>
            <RadioScale
              scale={defaultScale}
              onChange={handleScalePreviewChange}
              reversed={defaultReversed}
              value={scalePreview}
              positiveText={defaultPositiveText}
              negativeText={defaultNegativeText}
            />
          </Box>
        </Grid>
      </div> */}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/features/director/pages/template-editor/components/template-settings/TemplateSettings.tsx